export const RECEIVED_TYPES = {
    IN_RECEIVING : "InReceiving",
    RECEIVING_CLOSED : "ReceivingClosed"
}